/**
 * Created by lincoyanpalma on 08-05-20.
 */


export const statuses = {
    pending: ['pending', 'not-created'],
    failed: ['rejected-by-payer', 'marked-as-abuse', 'reversed'],
    success: ['normal', 'marked-paid-by-receiver']
}

export const isPending = (statusDetails = '') => {
    return statuses.pending.includes(statusDetails)
}

export const isFailed = (statusDetails = '') => {
    return statuses.failed.includes(statusDetails)
}

export const isSuccessful = (statusDetails = '') => {
    return statuses.success.includes(statusDetails)
}

export const getLabel = (statusDetails = '') => {
    return labels[statusDetails] || 'Status desconocido'
}

export const getStatusByDetail = (detail = '') => {

    if(detail === 'not-created' || detail === 'pending'){
        return 'pending'
    }

    return 'done'
}

export const labels = {
    'pending': 'Pendiente',
    'done': 'Pagado',
    // 'marked-paid-by-receiver': 'No Aplicable',
    // 'rejected-by-payer': 'Rechazado por el paciente',
    // 'marked-as-abuse': 'No solicitado por el paciente',
    // 'reversed': 'Reembolsado',
}